export default class  UpdateBackStockOrderStatu{
    id: number;
    orderStatus: number;
    reMark: string;
    abnormalImageUploadGuid: string;
    salesmanId?: number;
    orderNumber: string;
}